const TUIProfile = {
  "资料设置": "Edit profile",
  "头像": "Profile photo",
  "昵称": "Name",
  "账号": "Account",
  "个性签名": "Status",
  "性别": "Gender",
  "男": "Male",
  "女": "Female",
  "不显示": "Rather not say",
  "出生年月":"Birthday",
  "取消": "Cancel",
  "保存": "Save",
  "请选择出生日期": "Select the date of birthday",
  "选择头像": "Select Avatar",
  "设置昵称": "Setting Name",
  "仅限中文、字母、数字和下划线，2-20个字": "Chinese, letters, numbers and underscores only, 2-20 words",
  "请输入昵称": "Enter Name",
  "性别选择": "Select gender",
  "请输入内容": "Enter content",
  "用户ID": "userID",
  "暂未设置": "Not set yet"
}

export default TUIProfile;
